;(function () {
  /* jshint validthis: true */
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('PsdImportService', psdImportService)

  /* @ngInject */
  function psdImportService (SvgToolboxCustomerFontService) {
    this.aFonts = []

    this.filterTagAttrs = function (oTag, aIgnore) {
      return Object.keys(oTag).reduce(function (mObject, sAttr) {
        var bIgnore = aIgnore.indexOf(sAttr) > -1

        if (!bIgnore) {
          mObject[sAttr] = oTag[sAttr]
        }

        return mObject
      }, {})
    }

    this.prefixObject = function (sPrefix, mAttrs) {
      return Object.keys(mAttrs).reduce(function (mFlatNamespace, sKey) {
        var sAttrName = sPrefix + ':' + sKey

        if (sKey === 'value') {
          sAttrName = sPrefix
        }

        mFlatNamespace[sAttrName] = mAttrs[sKey]

        return mFlatNamespace
      }, {})
    }

    this.flatNamespaces = function (mNamespaces) {
      return Object.keys(mNamespaces).reduce(function (mNamespaceAttrs, sNamespace) {
        var mNamespace = mNamespaces[sNamespace] || {}
        return angular.extend({}, this.prefixObject(sNamespace, mNamespace))
      }.bind(this), {})
    }.bind(this)

    this.flatStyle = function (mStyle) {
      var mStylePolyfill = {
        'text-anchor': {
          left: 'start',
          center: 'middle',
          justify: 'middle',
          right: 'end'
        }
      }
      return Object.keys(mStyle).reduce(function (sStyle, sProperty) {
        var sValue = mStyle[sProperty]

        var mSvgStyle = mStylePolyfill[sProperty]
        if (mSvgStyle) {
          sValue = mSvgStyle[sValue]
        }

        var sPropertyValue = sProperty + ':' + sValue + ';'
        return sStyle + sPropertyValue
      }, '')
    }

    this.importTextToEditor = function (oEditor, oElem, mAttrs) {
      var bIsArray = oElem.innerText instanceof Array
      var bIsString = typeof oElem.innerText === 'string' && oElem.innerText.constructor === String

      var sInnerText = bIsArray ? oElem.innerText.join('\n') : bIsString ? oElem.innerText : ''

      var sFontFamily = SvgToolboxCustomerFontService.findEquivalentFont(oElem['font-family'])
      mAttrs['font-family'] = sFontFamily
      if (this.aFonts.indexOf(sFontFamily) === -1) {
        this.aFonts.push(sFontFamily)
      }

      if (oElem.transform) {
        var mMatrix = oElem.transform
        var aValues = [mMatrix.xx, mMatrix.xy, mMatrix.yx, mMatrix.yy, 0, 0]
        mAttrs.transform = 'matrix(' + aValues.join(' ') + ')'
      }

      oEditor.addText(sInnerText, mAttrs, { verticalCenterText: true, ignoreSave: true })
    }.bind(this)

    this.importToEditor = function (oEditor, aElems) {
      var aPropsToIgnore = [
        'tag',
        'children',
        'innerText',
        'transform',
        'xml',
        'xlink',
        '$$hashKey',
        'effects'
      ]

      oEditor.saveState()
      oEditor.destroyContent()
      oEditor.createBackgroundElement()

      aElems.forEach(function (oElem) {
        var mNamespaceAttrs = {
          xml: oElem.xml,
          xlink: oElem.xlink
        }
        var mAttrs = angular.extend({}, this.filterTagAttrs(oElem, aPropsToIgnore), this.flatNamespaces(mNamespaceAttrs), { style: this.flatStyle(oElem.style) })

        switch (oElem.tag) {
          case 'text':
            this.importTextToEditor(oEditor, oElem, mAttrs)
            break
          case 'image':
            oEditor.addImageBase64(oElem.xlink.href, mAttrs, { ignoreSave: true })
            break
        }
      }.bind(this))
    }.bind(this)

    return this
  }
})()
